<template>
  <div class="badge">
    <v-btn :title="title" :aria-label="title" :color="color" icon :to="to">
      <v-icon>mdi-bell-outline</v-icon>
    </v-btn>
    <router-link class="badge-text" :to="to">
      <span class="text--text bold-500">{{ text }}</span>
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "" },
    color: { type: String, default: "primary" },
    to: { type: [String, Object], default: "/" },
    text: { type: [String, Number], default: 0 }
  }
};
</script>

<style lang="scss" scoped>
.badge {
  cursor: pointer;
  div {
    display: inline-block;
  }
}
.badge-text {
  background: #ffcc33;
  color: var(--c-primary);
  border-radius: 10px;
  padding: 2px 6px 2px 5px;
  margin-left: -16px;
  z-index: 2;
  position: relative;
  border: 2px solid var(--bg-grey);
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
}
</style>
